import DeptPage from "@/pages/zones/DeptPage";
import { departmentsData } from "@/mocks/departments";

export default function Essonne91Page() {
  return <DeptPage dept={departmentsData["essonne-91"]} />;
}
